const m = require('air-vue-model')()
m.url = 'analytics'
m.name = 'analytics'

module.exports = m